import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getPropertyLocation, locationContent } from '../../data/location';

const Icon = ({ d }: { d: string }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d={d} />
  </svg>
);

export default function LocationSection() {
  const { t } = useTranslation();
  const loc = getPropertyLocation();
  const [mapFailed, setMapFailed] = useState(false);

  const mapSrc =
    `https://www.google.com/maps?q=${loc.latitude},${loc.longitude}&hl=en&z=14&output=embed`;

  return (
    <section id="location" className="location section section--soft">
      <div className="container">
        <header className="section-head section-head--center">
          <p className="eyebrow eyebrow--center reveal">{t('location.eyebrow')}</p>
          <h2 className="reveal">{t('location.title')}</h2>
          <p className="lede reveal">{t('location.subtitle')}</p>
        </header>

        <div className="location__layout">
          <div className="location__map reveal">
            {mapFailed ? (
              <div className="location__fallback">
                <p className="h">{t('location.mapError')}</p>
                <p>{locationContent.address}</p>
                <a href={locationContent.directionsUrl} target="_blank" rel="noreferrer" className="btn btn--ghost">
                  {t('location.openInMaps')}
                </a>
              </div>
            ) : (
              <iframe
                title="Villa Spilia map"
                src={mapSrc}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                onError={() => setMapFailed(true)}
              />
            )}
          </div>

          <aside className="location__aside reveal">
            <div className="contact-card">
              <div className="contact-row">
                <Icon d="M12 22s8-7 8-13a8 8 0 10-16 0c0 6 8 13 8 13z M12 11a2 2 0 100-4 2 2 0 000 4z" />
                <div>
                  <strong>{t('location.address')}</strong>
                  <p>{locationContent.address}</p>
                </div>
              </div>
              <div className="contact-row">
                <Icon d="M22 16.92V21a1 1 0 01-1.09 1 19.86 19.86 0 01-8.63-3.07 19.5 19.5 0 01-6-6A19.86 19.86 0 013.21 4.09 1 1 0 014.2 3h4.09a1 1 0 011 .75 12.32 12.32 0 00.7 2.81 1 1 0 01-.23 1L8.09 9.91a16 16 0 006 6l2.35-1.67a1 1 0 011-.23 12.32 12.32 0 002.81.7 1 1 0 01.75 1.02z" />
                <div>
                  <strong>{t('location.phone')}</strong>
                  <p><a href={`tel:${locationContent.phone.replace(/\s+/g, '')}`}>{locationContent.phone}</a></p>
                </div>
              </div>
              <div className="contact-row">
                <Icon d="M4 4h16c1 0 2 1 2 2v12c0 1-1 2-2 2H4c-1 0-2-1-2-2V6c0-1 1-2 2-2z M22 6l-10 7L2 6" />
                <div>
                  <strong>{t('location.email')}</strong>
                  <p><a href={`mailto:${locationContent.email}`}>{locationContent.email}</a></p>
                </div>
              </div>
              <a
                href={locationContent.directionsUrl}
                target="_blank"
                rel="noreferrer"
                className="btn btn--gold btn--sm"
              >
                {t('location.directions')}
                <span className="arrow" aria-hidden="true">→</span>
              </a>
            </div>

            <ul className="travel-list">
              <li className="travel-item">
                <strong>{t('location.byFerry')}</strong>
                <p>{locationContent.gettingHere.byFerry}</p>
              </li>
              <li className="travel-item">
                <strong>{t('location.byAir')}</strong>
                <p>{locationContent.gettingHere.byAir}</p>
              </li>
              <li className="travel-item">
                <strong>{t('location.byCar')}</strong>
                <p>{locationContent.gettingHere.byCar}</p>
              </li>
            </ul>
          </aside>
        </div>
      </div>
    </section>
  );
}
